import { Link } from "@tanstack/react-router";

const links = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Service" },
  { to: "/security", label: "Security Model" },
  { to: "/risk", label: "Security & Risk" },
  { to: "/support", label: "Support" },
] as const;


export function SiteFooter() {
  return (
    <footer className="mt-6 border-t border-border/80 pt-4 text-center">
      <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
        {links.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className="readout text-[10px] uppercase tracking-[0.14em] text-faint transition-colors hover:text-accent"
          >
            {label}
          </Link>
        ))}
      </nav>
      <p className="readout mt-3 text-[9px] leading-relaxed text-faint">
        Cobalt Wallet · Non-custodial XRP Ledger wallet. Keys are generated and encrypted on your
        device. Cobalt Wallet never holds your funds and cannot recover your phrase.
      </p>
    </footer>
  );
}
